// extracted by mini-css-extract-plugin
module.exports = {"youTubeWrapper":"style-module__youTubeWrapper___3BDB0"};